export { default as EthicalForm } from './EthicalForm';
